import { mapCommonFile } from './CommonFile.mappers';
import { mapPreviewPictureFromThumbnail } from './picture/BasePicture.mappers';
export const mapModel3d = (file, baseFile) => ({
  ...mapCommonFile(file, baseFile),
  fileOutput: mapPreviewPictureFromThumbnail(file),
  mediaType: '3d',
  width: null,
  height: null
});
//# sourceMappingURL=Model3D.mappers.js.map